import React from "react";

// COMPONENTS
import CardStats from "../Cards/CardStats";

// FONT AWESOME
import {
  faTasks,
  faLayerGroup,
  faCheck,
  faTimes,
  faUndo,
  faInbox,
  faHeadset,
  faSignature,
  faClipboardCheck,
  faCoins,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function HeaderStats({ count }) {
  return (
    <>
      {/* Header */}
      <div className="relative pb-8 ">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="grid grid-cols-5 gap-2">
              <div className="w-full">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faTasks} />}
                  statSubtitle="คำขอทั้งหมด"
                  statTitle={
                    count?.WAIT +
                    count?.WAIT_REFERAL +
                    count?.APPROVE +
                    count?.RETURN +
                    count?.COMPLETE +
                    count?.CANCEL +
                    count?.CONFIRMED +
                    count?.DONE +
                    count?.FINISHED +
                    count?.TRANSFER_FAIL
                  }
                  statArrow="up"
                  statPercent=""
                  statPercentColor="text-emerald-500"
                  statDescripiron=""
                  statIconName="fas fa-tasks"
                  statIconColor="bg-blue-700"
                />
              </div>
              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faInbox} />}
                  statSubtitle="รับคำร้อง"
                  statTitle={count.WAIT}
                  statArrow="down"
                  statPercent="3.48"
                  statDescripiron="Since last week"
                  statIconName="fas fa-file-text"
                  statIconColor="bg-gray-300"
                />
              </div>

              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faUndo} />}
                  statSubtitle="คำขอที่ถูกตีกลับ"
                  statTitle={count.RETURN}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-times"
                  statIconColor="bg-pink-400"
                />
              </div>
              <div className="w-full">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faHeadset} />}
                  statSubtitle="ติดต่อบุคคลอ้างอิง"
                  statTitle={count.WAIT_REFERAL}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-pink-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-times"
                  statIconColor="bg-orange-400"
                />
              </div>
              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faClipboardCheck} />}
                  statSubtitle="รออนุมัติ "
                  statTitle={count.APPROVE}
                  statArrow="down"
                  statPercent="1.10"
                  statPercentColor="text-purple-500"
                  statDescripiron="Since yesterday"
                  statIconName="fas fa-check"
                  statIconColor="bg-yellow-300"
                />
              </div>

              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faCheck} />}
                  statSubtitle="อนุมัติ"
                  statTitle={count.COMPLETE}
                  statArrow="down"
                  statPercent="1.10"
                  statPercentColor="text-orange-500"
                  statDescripiron="Since yesterday"
                  statIconName="fas fa-check"
                  statIconColor="bg-green-400"
                />
              </div>
              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faTimes} />}
                  statSubtitle="ไม่ผ่านเกณฑ์"
                  statTitle={count.CANCEL}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-undo"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faSignature} />}
                  statSubtitle="อยู่ระหว่างโอนเงินให้ลูกค้า"
                  statTitle={count.CONFIRMED}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-undo"
                  statIconColor="bg-purple-400"
                />
              </div>
              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faCoins} />}
                  statSubtitle="คำขอที่สมบูรณ์"
                  statTitle={count.DONE}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-undo"
                  statIconColor="bg-green-600"
                />
              </div>

              <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faBullseye} />}
                  statSubtitle="สิ้นสุด"
                  statTitle={count.FINISHED}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-undo"
                  statIconColor="bg-gray-600"
                />
              </div>

              {/* <div className="w-full ">
                <CardStats
                  statIcon={<FontAwesomeIcon icon={faBullseye} />}
                  statSubtitle="โอนเงินไม่สำเร็จ"
                  statTitle={count.TRANSFER_FAIL}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-undo"
                  statIconColor="bg-purple-600"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
